// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BOSAlert-module_bos_alert_Fk_5v {
  margin-top: 0 !important;
  max-width: 460px !important;
}

.BOSAlert-module_primary_alert_nxZpQ {
  border-top: 8px solid var(--primary-bos-color);
}

.BOSAlert-module_warning_alert_r6PJh {
  border-top: 8px solid var(--site-error-color);
}

.BOSAlert-module_bos_alert_Fk_5v > div:first-child {
  flex-direction: column;
  align-items: center;
  margin-top: -56px;
}

.BOSAlert-module_bos_alert_Fk_5v > div:first-child > span {
  margin: 0;
  color: var(--bp-light-gray5);
  border-radius: 30px;
  padding: 10px;
}

.BOSAlert-module_primary_alert_nxZpQ > div:first-child > span {
  background-color: var(--primary-bos-color);
}

.BOSAlert-module_warning_alert_r6PJh > div:first-child > span {
  background-color: var(--site-error-color);
}

.BOSAlert-module_content_title_xkgPR {
  margin-top: 8px !important;
  text-align: center;
}

.BOSAlert-module_bos_alert_Fk_5v > div:last-child {
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
}

.BOSAlert-module_bos_alert_Fk_5v > div:last-child button {
  font-size: 16px;
  padding: 10px 18px;
  margin: 0;
  flex-basis: 50%;
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Misc/BOSAlert.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EAEE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,YAAY;AACd","sourcesContent":[".bos_alert {\n  margin-top: 0 !important;\n  max-width: 460px !important;\n}\n\n.primary_alert {\n  composes: bos_alert;\n  border-top: 8px solid var(--primary-bos-color);\n}\n\n.warning_alert {\n  composes: bos_alert;\n  border-top: 8px solid var(--site-error-color);\n}\n\n.bos_alert > div:first-child {\n  flex-direction: column;\n  align-items: center;\n  margin-top: -56px;\n}\n\n.bos_alert > div:first-child > span {\n  margin: 0;\n  color: var(--bp-light-gray5);\n  border-radius: 30px;\n  padding: 10px;\n}\n\n.primary_alert > div:first-child > span {\n  background-color: var(--primary-bos-color);\n}\n\n.warning_alert > div:first-child > span {\n  background-color: var(--site-error-color);\n}\n\n.content_title {\n  margin-top: 8px !important;\n  text-align: center;\n}\n\n.bos_alert > div:last-child {\n  justify-content: center;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.bos_alert > div:last-child button {\n  font-size: 16px;\n  padding: 10px 18px;\n  margin: 0;\n  flex-basis: 50%;\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bos_alert": `BOSAlert-module_bos_alert_Fk_5v`,
	"primary_alert": `BOSAlert-module_primary_alert_nxZpQ BOSAlert-module_bos_alert_Fk_5v`,
	"warning_alert": `BOSAlert-module_warning_alert_r6PJh BOSAlert-module_bos_alert_Fk_5v`,
	"content_title": `BOSAlert-module_content_title_xkgPR`
};
export default ___CSS_LOADER_EXPORT___;
